<template>
  <main id="pages-search-dispensary-stack" class="ragnarok">
    <dispensary-banner :settings="dispensarySettings"></dispensary-banner>
    <div class="container">
      <h3 class="title is-3">{{this.stack.name}}</h3>
      <div class="columns is-multiline">
        <div v-for="product in stackProducts" class="column is-4-desktop is-6-tablet is-11-mobile stack-product">
          <product-tile
              :is-ragnarok="true"
              :product="product"
              :show-price="true"
              :show-add-to-cart="true"
              :show-ratings="true"
              :show-modal-on-add-to-cart="true"
              :add-to-cart-on-tile-click="true"
          />
        </div>
      </div>
      <div class="add-all-div">
        <base-buefy-button aria-label="Add Stack to Cart" type="is-dark" :disabled="hasUnorderableProducts" @click.prevent="addStackToCart">Add Stack to Cart</base-buefy-button>
      </div>
    </div>
  </main>
</template>

<script>
import DispensaryBanner from "~/components/dispensary/DispensaryBanner.vue";
import ProductTile from "../../../ProductTile.vue";
import CartService from "../../../../classes/customer/CartService";

let cartService;
export default {
  name: "DispensaryStackPage",
  components: { DispensaryBanner, ProductTile },

  data() {
    return {
      page: page,
      stack: stack,
      cartService: null
    }
  },
  mounted(){
    this.cartService = new CartService();
  },
  computed: {
    hasUnorderableProducts() {
      return this.stack.products &&
          Object.values(this.stack.products).some(product =>
              product.outOfStock || product.extendedBackorder
          );
    },

    dispensarySettings() {
      return {
        avatarUrl: page.avatarImageUrl,
        name: page.name,
        shopUrl: page.shopUrl,
        aboutUrl: page.aboutUrl,
        showAboutPage: page.showAboutPage
      }
    },

    stackProducts(){
      if(!this.stack.products){
        return [];
      }
      return Object.keys(this.stack.products)
          .map(key => parseInt(key, 10))
          .sort((a, b) => a - b)
          .map(id => this.stack.products[id]);

    }
  },

  methods: {
    addStackToCart(){
        if(this.hasUnorderableProducts){return;}

        const addedProducts = Object.values(this.stack.products)
            .map(product => {
              return {
                productId: product.id,
                quantity: 1
              }
            });

        this.cartService.addProducts(addedProducts)
            .then(() => {
              this.$buefy.notification.open({
                duration: 5000,
                type: "is-primary",
                position: "is-bottom",
                message: "Added stack to your cart.",
                role: "alert"
              });
            })
            .catch((err) => {
              this.$buefy.notification.open({
                duration: 5000,
                type: "is-danger",
                position: "is-bottom",
                message: "There was a problem adding the stack to your cart.",
                role: "alert"
              });
            });

      },
    },

}
</script>

<style lang="scss" scoped>
  .add-all-div{
    margin-bottom: 14px;
}
</style>